<ng-container *ngIf="isVisible">
  <div class="lightboxBackdrop" [@fadeIn]>
    <!-- Header with download + close buttons -->
    <div class="lightboxHeader">
      <div class="headerLeft">
        <sn-text-icon-button
          (click)="downloadImage()"
          [label]="'alpr.actions.downloadImage' | t"
          icon="download"
        ></sn-text-icon-button>
        <ng-content select="[fullscreenHeaderContent]"></ng-content>
      </div>
      <div class="headerRight">
        <sn-text-icon-button
          class="closeButton"
          [label]="'common.close' | t"
          icon="close"
          (click)="$event.stopPropagation(); closeLightbox()"
        ></sn-text-icon-button>
      </div>
    </div>
    <sn-icon-button class="arrowLeft" *ngIf="images.length > 1" (click)="prevImage()">
      <sn-icon fontSet="fal" fontIcon="fa-chevron-left"> </sn-icon>
    </sn-icon-button>

    <div class="lightboxContent" (click)="$event.stopPropagation()">
      <div class="lightboxBody">
        <img
          [src]="images[currentIndex].url"
          class="{{ images[currentIndex]?.class ?? '' }}"
          (error)="setPlaceholderImage($event)"
          [alt]="'alpr.lightbox.imageAlt' | t"
        />
      </div>
    </div>

    <sn-icon-button class="arrowRight" *ngIf="images.length > 1" (click)="nextImage()">
      <sn-icon fontSet="fal" fontIcon="fa-chevron-right"> </sn-icon>
    </sn-icon-button>

    <!-- Footer: Only show if multiple images exist -->
    <div class="lightboxFooter" *ngIf="images.length > 1" (click)="$event.stopPropagation()">
      <!-- Thumbnails row: each small preview is clickable -->
      <div class="thumbnails">
        <img
          *ngFor="let thumb of images; let i = index"
          [src]="thumb.url"
          [class.active]="i === currentIndex"
          (click)="currentIndex = i"
          [alt]="'alpr.lightbox.thumbnailAlt' | t"
        />
      </div>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="isDetailsView && !isVisible">
  <div [@fadeIn] class="detailsLightboxBackdrop">
    <!-- Header with view larger, mark for review and close buttons -->
    <div class="detailsLightboxHeader">
      <div class="headerLeft">
        <sn-text-icon-button
          [label]="'alpr.actions.viewLarger' | t"
          icon="fullscreen"
          class="detailsViewDarkbackgroundBtn"
          (click)="openLightboxFromDetailsView()"
          *ngIf="!hasImageLoadError && images.length > 0"
        ></sn-text-icon-button>
        <ng-content select="[detailsViewHeaderContent]"></ng-content>
      </div>
      <div>
        <sn-text-icon-button
          class="closeButton"
          [label]="'common.close' | t"
          icon="close"
          class="detailsViewDarkbackgroundBtn"
          (click)="closeRightSidenav()"
        ></sn-text-icon-button>
      </div>
    </div>
    <sn-icon-button class="detailsArrowLeft" *ngIf="images.length > 1" (click)="prevImage()">
      <sn-icon fontSet="fal" fontIcon="fa-chevron-left"> </sn-icon>
    </sn-icon-button>

    <div class="detailsLightboxContent" (click)="$event.stopPropagation()">
      <div class="detailsLightboxBody">
        <img
          [src]="images[currentIndex].url"
          (error)="setPlaceholderImage($event)"
          [alt]="'alpr.lightbox.imageAlt' | t"
          *ngIf="images.length > 0 && !hasImageLoadError"
        />

        <!-- Show external link UI when no valid images but external link exists -->
        <!-- NOTE: ONLY Flock V3 has this limitation, hence the hardcoded text -->
        <div
          class="flock-v3-external-link-lightbox"
          *ngIf="(images.length === 0 || hasImageLoadError) && hasExternalFlockV3Link"
          data-testid="flock-image-not-provided-lightbox"
        >
          <div class="flock-v3-external-link-content">
            <p>{{ 'alpr.flockSafety.imageNotProvided' | t }}</p>
            <sn-flat-button color="primary" (click)="openExternalFlockV3Link($event)" data-testid="view-in-flock-safety-lightbox-btn">
              <sn-icon>open_in_new</sn-icon>
              <sn-button-label>{{ 'alpr.actions.viewInFlockSafety' | t }}</sn-button-label>
            </sn-flat-button>
          </div>
        </div>

        <!-- Fallback placeholder for other cases -->
        <img
          src="/assets/map-icons/No_Image_Found.png"
          [alt]="'alpr.lightbox.noImageFoundAlt' | t"
          *ngIf="(images.length === 0 || hasImageLoadError) && !hasExternalFlockV3Link"
        />
      </div>
    </div>

    <sn-icon-button class="detailsArrowRight" *ngIf="images.length > 1" (click)="nextImage()">
      <sn-icon fontSet="fal" fontIcon="fa-chevron-right"> </sn-icon>
    </sn-icon-button>

    <!-- Footer: Only show if multiple images exist -->
    <div class="lightboxFooter" *ngIf="images.length > 1" (click)="$event.stopPropagation()">
      <!-- Thumbnails row: each small preview is clickable -->
      <div class="thumbnails">
        <img
          *ngFor="let thumb of images; let i = index"
          [src]="thumb.url"
          [class.active]="i === currentIndex"
          (click)="currentIndex = i"
          [alt]="'alpr.lightbox.thumbnailAlt' | t"
        />
      </div>
    </div>
  </div>
</ng-container>
